import React from 'react'
import Allroutes from './Components/Allroutes'
import Header from "./Components/Header"
import Hero from './Components/Hero/Hero'





const App = () => {
  return (
    <div>
      <Allroutes />
      {/* <NewHero /> */}
    </div>
  )
}

export default App